// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_2s1YT","itemPic":"index_itemPic_3CgTm"};